import { useTranslate } from "src/i18n";

export const usePlatformComprasionBlockTranslate = () => {
  const { t } = useTranslate();

  const title = t(
    "outsourcing.platform_comparison_block.title",
    "Сравнение платформ",
  );

  const description = t(
    "outsourcing.platform_comparison_block.description",
    "WooCommerce и InSales: два мощных решения для электронной коммерции",
  );

  const comparisonData = [
    {
      title: t(
        "outsourcing.platform_comparison_block.comparison_data.0.title",
        "Тип платформы",
      ),
      woocommerce: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.0.woocommerce.title",
          "Плагин для WordPress (самостоятельная установка)",
        ),
      },
      insales: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.0.insales.title",
          "Облачная SaaS-платформа",
        ),
      },
    },
    {
      title: t(
        "outsourcing.platform_comparison_block.comparison_data.1.title",
        "Стоимость",
      ),
      woocommerce: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.1.woocommerce.title",
          "Бесплатный плагин, но нужен хостинг, домен и платные расширения",
        ),
      },
      insales: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.1.insales.title",
          "Ежемесячная подписка (включает хостинг и поддержку)",
        ),
      },
    },
    {
      title: t(
        "outsourcing.platform_comparison_block.comparison_data.2.title",
        "Гибкость и кастомизация",
      ),
      woocommerce: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.2.woocommerce.title",
          "Высокая: полный доступ к коду, возможность глубокой настройки",
        ),
      },
      insales: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.2.insales.title",
          "Ограниченная: готовые шаблоны и функции, меньше возможностей для кастомизации",
        ),
      },
    },
    {
      title: t(
        "outsourcing.platform_comparison_block.comparison_data.3.title",
        "Простота использования",
      ),
      woocommerce: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.3.woocommerce.title",
          "Требует технических знаний для настройки и управления",
        ),
      },
      insales: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.3.insales.title",
          "Интуитивно понятный интерфейс, подходит для новичков",
        ),
      },
    },
    {
      title: t(
        "outsourcing.platform_comparison_block.comparison_data.4.title",
        "Масштабируемость",
      ),
      woocommerce: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.4.woocommerce.title",
          "Подходит для магазинов любого размера, но требует оптимизации",
        ),
      },
      insales: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.4.insales.title",
          "Легко масштабируется благодаря облачной инфраструктуре",
        ),
      },
    },
    {
      title: t(
        "outsourcing.platform_comparison_block.comparison_data.5.title",
        "Интеграции",
      ),
      woocommerce: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.5.woocommerce.title",
          "Огромное количество плагинов и интеграций (например, платежные системы, CRM)",
        ),
      },
      insales: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.5.insales.title",
          "Встроенные интеграции с популярными сервисами (маркетинг, аналитика, CRM)",
        ),
      },
    },
    {
      title: t(
        "outsourcing.platform_comparison_block.comparison_data.6.title",
        "SEO-возможности",
      ),
      woocommerce: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.6.woocommerce.title",
          "Гибкие настройки через плагины (например, Yoast SEO)",
        ),
      },
      insales: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.6.insales.title",
          "Встроенные инструменты для SEO",
        ),
      },
    },
    {
      title: t(
        "outsourcing.platform_comparison_block.comparison_data.7.title",
        "Техническая поддержка",
      ),
      woocommerce: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.7.woocommerce.title",
          "Зависит от хостинга и разработчиков плагинов",
        ),
      },
      insales: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.7.insales.title",
          "Встроенная поддержка, но зависит от тарифного плана",
        ),
      },
    },
    {
      title: t(
        "outsourcing.platform_comparison_block.comparison_data.8.title",
        "Производительность",
      ),
      woocommerce: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.8.woocommerce.title",
          "Зависит от качества хостинга и оптимизации сайта",
        ),
      },
      insales: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.8.insales.title",
          "Стабильная производительность благодаря облачной платформе",
        ),
      },
    },
    {
      title: t(
        "outsourcing.platform_comparison_block.comparison_data.9.title",
        "Обновления",
      ),
      woocommerce: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.9.woocommerce.title",
          "Необходимо самостоятельно обновлять плагины и ядро WordPress",
        ),
      },
      insales: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.9.insales.title",
          "Автоматические обновления платформы",
        ),
      },
    },
    {
      title: t(
        "outsourcing.platform_comparison_block.comparison_data.10.title",
        "Безопасность",
      ),
      woocommerce: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.10.woocommerce.title",
          "Зависит от хостинга и настроек (нужно самостоятельно настраивать защиту)",
        ),
      },
      insales: {
        title: t(
          "outsourcing.platform_comparison_block.comparison_data.10.insales.title",
          "Встроенная защита и SSL-сертификаты",
        ),
      },
    },
  ];

  return { title, description, comparisonData };
};
